import React from "react";
import DataGridAssure from "./datagrid/DataGridAssure";

const Assure = () => {
  return (
    <div>
      <DataGridAssure />
    </div>
  );
};

export default Assure;
